import * as React from 'react';

import { Paper, Typography, LinearProgress } from '@material-ui/core';

// tslint:disable-next-line:no-empty-interface
export interface ICardBigNumbersYearsProps {
    values: string[],
    loading: boolean,
    title: string,
}

// tslint:disable-next-line:no-empty-interface
export interface ICardBigNumbersYearsState {
}

export class CardBigNumbersYears extends React.Component<ICardBigNumbersYearsProps, ICardBigNumbersYearsState> {

    constructor(props: ICardBigNumbersYearsProps) {
        super(props);
    }

    public render() {

        return  (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="subheading" className="panel-title" component="title">
                    {this.props.title}
                </Typography>
                {this.props.loading && <LinearProgress />}
                {this.props.values && this.props.values.length > 0 && 
                    this.props.values.map((value:string, key:number) => {
                        return (
                            <Typography component="p" className="big-number" key={key}>
                                {value}
                            </Typography>
                        )
                    })
                }
            </Paper>
        )
    }
    
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/components/CardBigNumbersYears.tsx